import React from 'react'
import { Component } from 'reflux'
import { ExpectedDeliveryStatusActions, ExpectedDeliveryStatusStore, STATUS } from 'Stores/expectedDeliveryStatusStore'
import { Button, Form, Input, Row, Col, Label } from 'reactstrap'
import _ from 'lodash'
import CollapsibleCard from 'Components/collapsibleCard'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class ExpectedDeliveryStatusForm extends Component {
  constructor(props) {
    super(props)
    this.stores = [ExpectedDeliveryStatusStore]
    this.storeKeys = ['status', 'expectedDeliveryStatusDetails']
  }

  resetExpectedDeliveryStatus = () => {
    if (_.get(this.props, 'match.params.ExpectedDeliveryStatusID')) {
      ExpectedDeliveryStatusActions.getExpectedDeliveryStatusDetails(this.props.match.params.ExpectedDeliveryStatusID)
    } else {
      ExpectedDeliveryStatusActions.createEmptyExpectedDeliveryStatus()
    }
  }

  render() {
    if (this.state.status === STATUS.REDIRECT) {
      return <Redirect to='/expected-delivery-status' />
    }

    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }

    return (
      <>
        <CollapsibleCard startOpen header={<strong>{_.get(this.props, 'match.params.ExpectedDeliveryStatusID') ? 'Detaljer' : 'Opret'}</strong>}>
          <Form>
            <Row className='mb-2'>
              <Col xs='2'>
                <Label for='statusType'>Type (farve i klubben)</Label>
              </Col>
              <Col xs='10'>
                <Input
                  type='select'
                  name='statusType'
                  value={this.state.expectedDeliveryStatusDetails.statusType}
                  onChange={e => {
                    ExpectedDeliveryStatusActions.updateExpectedDeliveryStatusField(e)
                  }}
                >
                  <option value=''>Vælg type</option>
                  <option value='RED'>RED</option>
                  <option value='YELLOW'>YELLOW</option>
                  <option value='GREEN'>GREEN</option>
                </Input>
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col xs='2'>
                <Label for='name'>Navn (internt)</Label>
              </Col>
              <Col xs='10'>
                <Input
                  type='text'
                  value={this.state.expectedDeliveryStatusDetails.name}
                  name='name'
                  id='name'
                  onChange={ExpectedDeliveryStatusActions.updateExpectedDeliveryStatusField}
                  invalid={!this.state.expectedDeliveryStatusDetails.name.length}
                />
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col xs='2'>
                <Label for='description'>Beskrivelse (vises i klubben)</Label>
              </Col>
              <Col xs='10'>
                <Input
                  type='text'
                  value={this.state.expectedDeliveryStatusDetails.description}
                  name='description'
                  id='description'
                  onChange={ExpectedDeliveryStatusActions.updateExpectedDeliveryStatusField}
                  invalid={!this.state.expectedDeliveryStatusDetails.description.length}
                />
              </Col>
            </Row>
            <Button
              onClick={ExpectedDeliveryStatusActions.saveExpectedDeliveryStatus}
              disabled={this.state.status === STATUS.IS_SAVING || !this.state.expectedDeliveryStatusDetails.name.length}
            >
              {this.state.status === STATUS.IS_SAVING ? <FontAwesomeIcon icon='spinner' spin /> : 'Gem'}
            </Button>
            <Button color='danger' onClick={this.resetExpectedDeliveryStatus} className='ml-2'>
              Nulstil
            </Button>
          </Form>
        </CollapsibleCard>
      </>
    )
  }
}
